export { EStorageType, ELocalStorageKeys, ESessionStorageKeys } from '@web-store-platforms/types';
